import { gql } from "@apollo/client";

const GET_COS_PDF = gql`
  query cosPdf($omobilityID: String!) {
    cosPdf(omobilityID: $omobilityID)
  }
`;

export default GET_COS_PDF;
